module.exports = __webpack_public_path__ + "static/media/75.4b10fa78.jpg";